import * as Yup from 'yup'
import React from 'react'
import { FastField, Form, Formik, FormikProps } from 'formik'

import FormikTextarea from '../FormikTextarea'

type ReplyFormProps = {
  onSubmit: (values: { reply: string }) => void
}

const schema = Yup.object().shape({
  reply: Yup.string().required(),
})

const ReplyForm: React.FC<ReplyFormProps> = (props) => {
  return (
    <Formik
      enableReinitialize
      initialValues={{
        reply: '',
      }}
      validationSchema={schema}
      validateOnChange={false}
      validateOnBlur={false}
      onSubmit={props.onSubmit}
    >
      {({ isSubmitting, dirty }: FormikProps<{ reply: string }>) => (
        <Form>
          <fieldset disabled={isSubmitting} className="mb-6">
            <FastField type="text" component={FormikTextarea} placeholder="Type your reply" name="reply" />
          </fieldset>

          <div className="flex items-center">
            <p className="text-sm font-normal leading-5 text-gray-500">
              You are only able to respond once. After you have responded, the user can start a conversation with you.
            </p>
            <button className="btn btn-primary ml-auto" type="submit" disabled={!dirty || isSubmitting}>
              Submit Reply
            </button>
          </div>
        </Form>
      )}
    </Formik>
  )
}

export default ReplyForm
